var _style, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockupHumana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4431.2 771.8",
    style: {
      enableBackground: "new 0 0 4431.2 771.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#A5A8AA;stroke-width:14;stroke-miterlimit:10;}\n\t.st1{fill:#00BED5;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:#87C546;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2331.1,
    y1: 0,
    x2: 2331.1,
    y2: 771.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4251,561.1V175.5c0-3,2.4-5.4,5.4-5.4h39.4c19,0,34.4,15.4,34.4,34.4v385.6c0,3-2.4,5.4-5.5,5.4h-39.3 C4266.4,595.5,4251,580.1,4251,561.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3583.4,416.2v170.7c0,4.7-3.9,8.6-8.6,8.6l0,0h-32c-20.6,0-37.3-16.7-37.3-37.3l0,0V432.7 c0-41.3-23.6-69-59.6-69c-44.2,0-73.1,29.5-73.1,101.4v121.7c0,4.7-3.9,8.6-8.6,8.6l0,0h-32c-20.6,0-37.3-16.7-37.3-37.3l0,0 V179.4c0-4.7,3.8-8.6,8.6-8.6h32c20.6,0,37.3,16.7,37.3,37.3l0,0v119.6c23-23,53.6-35.4,92.6-35.4 C3536.2,292.4,3583.4,343.1,3583.4,416.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3694.1,414.4h142.1c-10-37.8-38.3-54.2-69.6-54.2C3737.2,360.2,3703.5,377.9,3694.1,414.4 M3907.3,469.3 h-215.5c7.7,42.5,37.8,65.6,73.7,65.6c21.9,0,47.6-1.2,68.4-32.3c1.9-3,5.5-4.5,9-3.8l53.3,11.3c4.6,1,7.6,5.5,6.6,10.1 c-0.1,0.7-0.3,1.3-0.6,1.9c-27.2,54.7-75.9,79.5-136.7,79.5c-83.1,0-151-60.3-151-152.9s67.9-156.3,152.2-156.3 c78.4,0,146.3,60.8,149.2,150.4v18C3915.8,465.4,3912,469.3,3907.3,469.3L3907.3,469.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4135.7,476.4v-3.5h-86.1c-24.8,0-41.3,13.6-41.3,33.6c0,21.8,20,36,50.1,36 C4099.7,542.4,4135.7,514.1,4135.7,476.4 M4210,403.3v183.6c0,4.7-3.9,8.6-8.6,8.6l0,0h-41.6c-13.3,0-24.1-10.8-24.1-24.1l0,0 v-0.1c-20.1,19.5-49.6,30.2-89.7,30.2c-67.2,0-112.1-35.5-112.1-93.3c0-56.6,42.5-94.4,116.8-94.4h85v-4.7 c0-29.5-20.1-49.5-50.1-49.5c-15.1,0-45.7-0.6-53.3,23.9c-1.3,4.1-5.5,6.6-9.8,5.7l-52.7-10.4c-4.7-1-7.7-5.6-6.7-10.3 c0.1-0.3,0.1-0.5,0.2-0.8c14.8-52,71.5-75.3,117.6-75.3C4158.8,292.3,4210.1,331.9,4210,403.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2647.6033,
    y1: -80.7337,
    x2: 2900.4534,
    y2: 65.2465,
    gradientTransform: "matrix(1 0 0 1 0 272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BED5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#00BED5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#09C0D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#21C4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#49CCDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#7FD6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#95DAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#95DAE9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2730.1,178.8c-35.6,15.5-60.3,58.6-61.2,117.9c-0.1,5.2,1.8,10.2,5.1,14.1c17.6,20.3,50.8,46.4,101.8,38.4 c34.4-5.4,64-34.3,84.6-61.2c8.1-11.8,14.6-24.5,19.6-37.9c2.4-6.7,1.4-14.2-2.6-20.1C2839.5,175.6,2785.6,154.7,2730.1,178.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 4142.4995,
    y1: -3002.969,
    x2: 4144.6494,
    y2: -3002.969,
    gradientTransform: "matrix(-145.38 251.8 251.8 145.38 1361457.75 -606407.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5426E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F5426E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#F64772"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#F7577F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#FA7195"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FE94B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#FF9BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9BB8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3127.6,205c-23.2-22.6-54.4-35.2-86.8-35.3c-31.6,0-62.9,12.4-85.4,38.4c-16.5,19.1-33,39.7-48.8,60.6 c-0.5,0.8-44.1,66.8-91.3,89.5l0,0c-11.2,6.3-23.4,10.6-36.1,12.7c-7.2,1.1-14.5,1.7-21.8,1.7c-32.2,0-57.4-11.7-76.2-25.8 c-1.9-1.5-4.7-1.1-6.1,0.9c-0.7,1-1,2.3-0.8,3.5c7.3,35.7,22.2,75,46.7,116.4c84.3,141.9,179.2,135.3,179.2,135.3 s1.1,0.1,3.2,0.1h0.7c22.1-0.1,135.6-9.3,240.7-180.3C3194.4,341.9,3174,250.3,3127.6,205z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4381.2,176.2v26.5h-5.6v-26.5h-10.7v-4.7h27.2v4.7H4381.2z M4425.9,202.7v-21l-10.1,20.7h-3.5l-10.1-20.7 v21h-5.3v-31.2h6l11.1,22.3l11.3-22.3h5.9v31.2H4425.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2087.3,547.6c-0.4,19.9-16.8,35.8-36.8,35.4c-19.9-0.4-35.8-16.8-35.4-36.8c0.4-19.8,16.6-35.6,36.4-35.4 c20,0.2,36,16.6,35.8,36.5C2087.3,547.5,2087.3,547.6,2087.3,547.6 M2022.8,547.6c1,15.8,14.7,27.8,30.5,26.7 c15.8-1,27.8-14.7,26.7-30.5c-1-15-13.4-26.7-28.5-26.8c-16.1,0.2-29,13.5-28.8,29.6C2022.8,547,2022.8,547.3,2022.8,547.6  M2050.6,527.5c9.8,0,16.1,2.8,16.1,11.5c0.5,5.6-2.8,10.8-8.1,12.6l2.4,4.2c2.2,3.7,4.6,7.2,7.2,10.7c0.4,0.7-0.8,1.1-2.8,1.1 h-2.4c-2.4,0-3.1-0.5-3.5-0.9c-2-2.6-3.8-5.3-5.4-8.1l-3.5-6.3h-5.2v14.2c0,0.4-0.8,0.9-2.3,0.9h-3.2c-1.5,0-2.4-0.5-2.4-0.9 v-38.8h13.1V527.5z M2045.4,546h5.8c5.6,0,7.8-2.7,7.8-6.3c0-4.9-4.6-5.6-8.7-5.6h-4.9V546z M550.3,275.7 c-6.1,0.1-11,5-11.1,11.1v231.5c-17.4,4-35.3,6-53.2,5.9c-39.8,0-54.3-14.8-54.3-58.3V286.8c0.3-6-4.3-11.1-10.3-11.3 c-0.2,0-0.3,0-0.5,0H360v190.9c0,89.5,47.3,118.6,123.8,118.6c42.9-0.9,85.5-7.2,126.7-18.9V275.8L550.3,275.7z M1480.3,581.5 c6.2-0.1,11.2-5.1,11.2-11.4V336.7c17.4-4.1,35.2-6.2,53.1-6.3c39.9,0,54.3,14.8,54.3,58.4v181.4c-0.3,6,4.3,11.1,10.3,11.3 c0.2,0,0.3,0,0.5,0h60.9V388.7c0-89.5-47.3-118.5-123.8-118.5c-42.9,0.9-85.5,7.3-126.7,18.9v292.3L1480.3,581.5L1480.3,581.5z  M1237.5,270.6c-78.8,0-128.5,42.7-128.5,134.1v46.1c0,101.3,53.8,134.2,112,134.2c26.2-1.6,50.6-13.5,67.9-33.2v18.9 c0.2,5.8,4.8,10.5,10.7,10.7h60.7V288c-40.1-10.9-81.4-16.8-122.9-17.5 M1288.7,507.2c-13.2,11-23.4,18.2-51.4,18.9 c-39.9,0-56.8-24.4-56.8-76.5v-42.1c0-60,22.1-76.5,56.8-76.5c17.2-0.4,34.4,0.8,51.4,3.7V507.2z M1849.1,270.6 c-78.9,0-128.6,42.7-128.6,134.1v46.1c0,101.3,53.8,134.2,112.1,134.2c26.2-1.5,50.7-13.5,68-33.2v18.9 c0.2,5.9,4.9,10.6,10.9,10.7h60.8V288c-40.1-10.9-81.4-16.8-122.9-17.5 M1900.7,507.2c-13.2,11-23.5,18.2-51.4,18.9 c-40,0-57.2-24.4-57.2-76.5v-42.1c0-60,22.1-76.5,57.2-76.5c17.2-0.4,34.4,0.8,51.4,3.7V507.2z M0,581.4h64.2 c5.8-0.3,10.4-4.9,10.8-10.7V401.3h118.3c18.3-0.3,33.5,14.1,34.3,32.4v136.9c0.1,5.9,4.8,10.7,10.7,10.9h64.2v-402h-64.2 c-5.6,0.1-10.3,4.5-10.7,10.1v151H104.4c-15.9,0-29-12.6-29.5-28.6V189.6c-0.5-5.6-5.1-10-10.8-10.1H0V581.4z M949.7,270.3 c-28.5,0.2-56.4,8.3-80.6,23.3c-22-16.5-51.9-23.3-88.9-23.3c-37.5,0.3-74.6,7.1-109.8,20.1v291.1h60.7 c6.1-0.1,10.9-5.2,10.8-11.3v-0.1V336.2c11.4-3.4,23.2-5.1,35.1-5.3c41.9,0,52.1,16.8,52.1,58.4v180.9c0,6.1,4.8,11.1,10.9,11.4 h50c5.9,0.1,10.8-4.7,10.9-10.6c0-0.3,0-0.6,0-0.8v-225c11.8-9.5,26.6-14.5,41.8-14.3c32.4,0,45.5,14.6,45.5,54.3v184.9 c-0.1,6.1,4.7,11.2,10.8,11.4h60.5V375.1c0-78.2-48.8-105-109.7-105"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockupHumana);
export default __webpack_public_path__ + "static/media/lockup_humana.37758cef52856ef4e587ddee62a1d9cf.svg";
export { ForwardRef as ReactComponent };